<template>
    <div class="AlphabetSystemMemoView">
        <div class="top-section-wrapper">
            <div class="progress-bar-wrapper">
                <div class="progress-bar" :style="{ width: progressBarPercentageWidth }" />
            </div>
            <div class="exit-button-wrapper" @click="$router.go(-1)">Exit</div>
        </div>
        <carousel ref="carousel" :per-page="1" :pagination-enabled="false">
            <slide v-for="item in itemsByJourney" :key="item.name" class="slide">
                <p class="item-number">
                    {{ item.number }}
                </p>
                <p class="first-letter-styled">
                    {{ item.name }}
                </p>
                <img :src="createImagePath(item.number)" :alt="item" />
            </slide>
        </carousel>
        <div class="direction-buttons-wrapper" :class="{ isLastSlide }">
            <button :disabled="!currentPage" @click="goToPreviousSlide">
                <svgicon icon="arrow-left" class="arrow-icon" />
            </button>
            <button v-if="!isLastSlide" :disabled="isLastSlide" @click="goToNextSlide">
                <svgicon icon="arrow-right" class="arrow-icon" />
            </button>
            <button v-else class="start-quiz-button" @click="goToQuizView">Start quiz</button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Carousel, Slide } from 'vue-carousel';

import memoMixin from './memo.mixin';

export default {
    components: {
        Carousel,
        Slide
    },

    mixins: [memoMixin],

    computed: {
        itemsByJourney() {
            return this.step.name === 'From u to z and beyond' ? this.step.items[this.currentLocale] : this.step.items;
        }
    },

    methods: {
        createImagePath(imageName) {
            const alphabetSystemImageName = imageName.split('-')[0];
            // we can't have line breaks in src string thats why disable pretttier for this line
            // prettier-ignore
            return require(`@/assets/images/system-images/${this.urlifyString(this.system.name)}/${this.urlifyString(this.journey.name)}/${this.urlifyString(this.step.name)}/${alphabetSystemImageName}.jpg`);
        }
    }
};
</script>

<style lang="scss" scoped>
.AlphabetSystemMemoView {
    width: 375px;
    height: 809px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 10px;
    .top-section-wrapper {
        .progress-bar-wrapper {
            .progress-bar {
                transition: 0.3s;
                height: 3px;
                background: white;
            }
        }
        .exit-button-wrapper {
            text-align: right;
            margin-top: 10px;
            color: hsla(0, 0%, 100%, 0.5);
        }
    }
    .slide {
        background-color: rgba(0, 0, 0, 0.1);
        min-height: 337px;
        width: 90%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        border-radius: 10px;
        .shape-wrapper {
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
            width: 100%;
            display: flex;
            justify-content: center;
            .numbershape {
                width: 75px;
                height: 75px;
            }
        }
        img {
            width: 150px;
            height: 150px;
            border-radius: 10px;
        }
        .item-number {
            padding: 0;
            font-size: 26px;
            text-transform: uppercase;
        }
        p {
            font-size: 18px;
            text-align: center;
            padding: 20px 0;
            margin: 0;
        }
        .first-letter-styled::first-letter {
            text-transform: uppercase;
            font-weight: bold;
        }
    }
    .direction-buttons-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        transition: 0.5s;
        width: 100%;
        position: relative;
        button {
            width: 35px;
            height: 35px;
            margin: 10px;
            background: inherit;
            border: none;
            outline: none;
            cursor: pointer;
            &:disabled {
                opacity: 0.5;
            }
            .arrow-icon {
                width: 100%;
                height: 100%;
                fill: white;
            }
        }

        .start-quiz-button {
            min-width: 100px;
            background-color: white;
            border-radius: 5px;
            font-size: 16px;
            line-height: 35px;
            margin: 0;
        }

        &.isLastSlide {
            width: calc(50% + 50px);
            height: 55px;

            button:first-of-type {
                position: absolute;
                right: 150px;
            }
            .start-quiz-button {
                position: absolute;
                right: 0;
            }
        }
    }
}
</style>
